import React from 'react';

interface ErrorMessageProps {
    message: string;
    description?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
                                                       message,
                                                       description
                                                   }) => {
    const containerStyle: React.CSSProperties = {
        padding: '12px 16px',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderLeft: '4px solid #ef4444',
        borderRadius: '6px',
        margin: '8px 0',
        color: '#dc2626',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '14px',
        lineHeight: '1.4'
    };

    const titleStyle: React.CSSProperties = {
        fontWeight: '600',
        margin: '0 0 4px 0',
        fontSize: '14px'
    };

    const descriptionStyle: React.CSSProperties = {
        margin: '0',
        fontSize: '13px',
        opacity: 0.8
    };

    return (
        <div style={containerStyle}>
            <div style={titleStyle}>{message}</div>
            {description && (
                <div style={descriptionStyle}>{description}</div>
            )}
        </div>
    );
};

export default ErrorMessage;
